(() => {
  const sections = Array.from(document.querySelectorAll("[data-featured-deck]"));
  if (!sections.length) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  // Symmetric halo around the center card: three tidy tiles per side.
  // x/y are % of half the stage width/height. No slot touches the main card.
  // Satellites are sized by CSS; keep scale ~1 so text renders sharp.
  const WINGS = [
    { x: -56, y: -66, s: 1, r: -4 },
    { x: 56, y: -66, s: 1, r: 4 },
    { x: -76, y: 0, s: 1.04, r: -2 },
    { x: 76, y: 0, s: 1.04, r: 2 },
    { x: -56, y: 66, s: 0.97, r: -5 },
    { x: 56, y: 66, s: 0.97, r: 5 },
    { x: -92, y: -44, s: 0.94, r: -6 },
    { x: 92, y: 44, s: 0.94, r: 6 }
  ];

  sections.forEach((section) => {
    const stage = section.querySelector("[data-deck-stage]");
    const cards = Array.from(section.querySelectorAll("[data-deck-card]"));
    const progressBar = section.querySelector("[data-deck-progress]");
    if (!stage || !cards.length) return;

    const main = cards[0];
    const satellites = cards.slice(1);

    // On phones the deck becomes a CSS "peek-deck shuffle" (see featured-deck.css).
    // The JS must not write inline transforms there or it fights the keyframes.
    const mqMobile = window.matchMedia("(max-width: 700px)");
    const resetInline = () => {
      [main, ...satellites].forEach((card) => {
        card.style.transform = "";
        card.style.opacity = "";
        card.style.zIndex = "";
        card.style.pointerEvents = "";
      });
      if (progressBar) progressBar.style.width = "";
    };

    const apply = (split, drift) => {
      if (mqMobile.matches) {
        resetInline();
        return;
      }
      const rect = stage.getBoundingClientRect();
      const halfW = rect.width / 2;
      const halfH = rect.height / 2;
      const isNarrow = rect.width < 700;

      main.style.transform = "translate(-50%, -50%)";
      main.style.opacity = "1";
      main.style.zIndex = "100";
      main.style.pointerEvents = "auto";

      satellites.forEach((card, i) => {
        const slot = WINGS[i % WINGS.length];
        const t = easeOut(clamp((split - i * 0.04) / 0.84, 0, 1));
        // Narrow screens: satellites tuck in close behind the main card.
        const xm = isNarrow ? 0.55 : 1;
        const sm = isNarrow ? 0.85 : 1;
        const om = isNarrow ? 0.5 : 0.98;
        const x = (slot.x / 100) * halfW * t * xm;
        const y = (slot.y / 100) * halfH * t + drift * 8 * (i % 2 === 0 ? 1 : -1);
        const scale = lerp(0.88, slot.s * sm, t);
        card.style.transform =
          `translate(-50%, -50%) translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) rotate(${(slot.r * t).toFixed(2)}deg) scale(${scale.toFixed(3)})`;
        card.style.opacity = (om * clamp(t * 1.4, 0, 1)).toFixed(3);
        card.style.zIndex = String(30 + i);
        card.style.pointerEvents = t > 0.8 && !isNarrow ? "auto" : "none";
      });

      if (progressBar) {
        progressBar.style.width = `${Math.round(split * 100)}%`;
      }
    };

    if (reducedMotion) {
      apply(1, 0);
      return;
    }

    let frame = 0;
    let isVisible = false;

    const render = () => {
      const travel = Math.max(1, section.offsetHeight - window.innerHeight);
      const progress = clamp(-section.getBoundingClientRect().top / travel, 0, 1);
      // Split completes in the first 60% of travel; the rest holds with a soft drift.
      const split = clamp(progress / 0.6, 0, 1);
      const drift = clamp((progress - 0.6) / 0.4, 0, 1);
      apply(split, drift);
    };

    const loop = () => {
      if (!isVisible || mqMobile.matches) {
        frame = 0;
        return;
      }
      render();
      frame = window.requestAnimationFrame(loop);
    };

    render();

    // Hand control between JS (desktop) and CSS (mobile) as the viewport crosses 700px.
    const onBreakpoint = () => {
      if (mqMobile.matches) {
        resetInline();
        if (frame) {
          window.cancelAnimationFrame(frame);
          frame = 0;
        }
      } else if (isVisible && !frame) {
        frame = window.requestAnimationFrame(loop);
      } else {
        render();
      }
    };
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener("change", onBreakpoint);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(onBreakpoint);
    }

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          isVisible = entries.some((entry) => entry.isIntersecting);
          if (isVisible && !frame) {
            frame = window.requestAnimationFrame(loop);
          }
        },
        { rootMargin: "10% 0px 10% 0px" }
      );
      observer.observe(section);
    } else {
      isVisible = true;
      frame = window.requestAnimationFrame(loop);
    }

    window.addEventListener("resize", () => {
      if (!frame) render();
    });
  });
})();
